<template>
  <transition name="fade" mode="out-in">
    <Onboard v-if="onboard" @close="onboard = false" />

    <div v-else class="page">
      <SiteNav />
      <MobileNav />
      <template v-for="(section, key) in $page?.sections">
        <template v-if="section.flexLayout === 'home-banner'">
          <SectionHeader :section="section"></SectionHeader>
        </template>

        <template v-if="section.flexLayout === 'menus-section'">
          <SectionMenus :section="section" />
        </template>

        <template v-if="section.flexLayout === 'experiences-section'">
          <SectionExperiences
            :section="section"
            :etablissements="etablissements"
            @carousel="(e) => (carousel = e)"
          />
        </template>

        <template v-if="section.flexLayout === 'careers-section'">
          <section class="section-career" id="carrieres">
            <h2 class="section-career__title" v-reveal>{{ section.title }}</h2>
            <SectionImage
              v-reveal
              :gallery="false"
              :images="[section.image]"
              white
              :button="{ label: section.label, link: section.link }"
              :text="section.description"
              :title="section.subtitle"
              style="color: black"
            />
          </section>
        </template>
      </template>

      <Footer id="contact" />

      <Gdpr />
      <Popup />

      <transition name="fade" appear>
        <Carousel :carousel="carousel" @close="carousel = null" v-if="carousel" />
      </transition>
    </div>
  </transition>
</template>

<script>
import Carousel from '@/components/Carousel.vue'
import Footer from '@/components/Footer.vue'
import Gallery from '@/components/Gallery.vue'
import Gdpr from '@/components/gdpr/Gdpr.vue'
import Popup from '@/components/modal/Popup.vue'
import MobileNav from '@/components/navigation/MobileNav.vue'
import SiteNav from '@/components/navigation/SiteNav.vue'
import Onboard from '@/components/Onboard.vue'
import SectionExperiences from '@/components/SectionExperiences.vue'
import SectionHeader from '@/components/SectionHeader.vue'
import SectionImage from '@/components/SectionImage.vue'
import SectionMenus from '@/components/SectionMenus.vue'
import { setMeta } from '@/helpers/metaHelpers'
import PageMetaMixin from '@/mixins/PageMetaMixin.js'

export default {
  name: 'Home',
  components: {
    SectionExperiences,
    Carousel,
    SectionHeader,
    SectionMenus,
    MobileNav,
    Gallery,
    Footer,
    SectionImage,
    Gdpr,
    SiteNav,
    Onboard,
    Popup,
  },
  mixins: [PageMetaMixin],
  inject: ['mq'],
  beetPage: 'home',
  view: 'home',
  data() {
    return {
      onboard: true,
      carousel: null,
    }
  },
  watch: {
    $page(to) {
      if (!to?.seo) return

      setMeta({
        ...to.seo,
        image: to.seo.image?.original,
      })
    },

    '$route.hash': {
      immediate: true,

      handler(hash) {
        const cleanHash = (hash || '').replace('#', '')

        const isFaqHash = cleanHash === 'faq' || cleanHash.startsWith('faq-')

        if (isFaqHash) {
          this.onboard = false
          this.$router.replace(this.getLocalRoute({ name: 'faq', hash }))
          return
        }

        this.onboard = !cleanHash && !this.$store.getters.onboardSeen

        if (this.onboard) {
          this.$store.commit('setOnboardSeen')
        }
      },
    },
  },
  computed: {
    etablissements() {
      const etablissement = Object.values(this.$page?.sections).find(({ flexLayout }) => {
        return flexLayout === 'businesses-section'
      })

      etablissement.data = Object.values(this.$beet.businesses)
      return etablissement || {}
    },
  },
}
</script>
